const vapeukwholesale = {
    id: 'vapeukwholesale',
    publicSiteName: 'Vape UK Wholesale',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#60a543',
            secondary: '#444444',
            color1: '#7ed958',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/vapeukwholesale/favicon.ico',
        logo: '/vapeukwholesale/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default vapeukwholesale